import { render, staticRenderFns } from "./BonificiXml.vue?vue&type=template&id=1aacde55&scoped=true"
import script from "./BonificiXml.vue?vue&type=script&lang=js"
export * from "./BonificiXml.vue?vue&type=script&lang=js"
import style0 from "./BonificiXml.vue?vue&type=style&index=0&id=1aacde55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aacde55",
  null
  
)

export default component.exports